import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppSearchSiteRoutingModule } from './app-search-site-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { AppSearchSiteViewComponent } from './app-search-site-view/app-search-site-view.component';
import { DeleteMeComponent } from './delete-me/delete-me.component';
import { SitesModule } from 'src/app/admin/1.tv/sites/sites.module';
import { CompanySiteToStoreModule } from 'src/app/theBookableServices/services/company-site-to-store/company-site-to-store.module';
import { AdmirUserMenuComponent } from '../admir-user-menu/admir-user-menu.component';



@NgModule({
  declarations: [
    AppSearchSiteViewComponent,
    DeleteMeComponent,
    AdmirUserMenuComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    AppSearchSiteRoutingModule,
    SitesModule,
    CompanySiteToStoreModule
  ],
  exports: [SitesModule]
})
export class AppSearchSiteModule { }
